import { FlexContainer, Label } from '@facephi/ui-react';
import { TimelineStepProps } from './model';
import { IconResult, TimelineStepStyles, TimelineSubtitle } from './Styles';

export const TimelineStep = ({
  message,
  timeUpdate,
  children,
  className,
  testId,
  separation,
  isError,
  isSuccess,
}: TimelineStepProps) => {
  return (
    <TimelineStepStyles
      style={{ paddingBottom: separation }}
      className={className}
      data-test={testId}
      isError={isError}
      isSuccess={isSuccess}
    >
      {(isSuccess || isError) && (
        <IconResult
          iconName={isError ? 'XCircle' : 'CheckCircle'}
          color={isError ? 'error400' : 'success400'}
          size="14"
        />
      )}
      <Label
        color={isError ? 'error400' : isSuccess ? 'success400' : undefined}
        fontSize="12"
        semibold={isError}
      >
        {message}
      </Label>
      {!isError && (
        <TimelineSubtitle fontSize="10" semibold>
          {timeUpdate}
        </TimelineSubtitle>
      )}
      {children && (
        <FlexContainer wrap="wrap" rowGap="1" columnGap="1">
          {children}
        </FlexContainer>
      )}
    </TimelineStepStyles>
  );
};
